import type { OnInit } from '@angular/core';
import {
  Component,
  effect,
  forwardRef,
  inject,
  Injector,
  input,
  untracked,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor, OnyxOptional } from '@onyx/angular';
import {
  OnyxInformationHeadingComponent,
  OnyxLinkComponent,
} from '@onyx/angular';
import { RouteComponent } from '../../../../../../../common/components/route/route.component';
import type { FuelType } from '../../../../../../../common/enums/fuel-type';
import type { TelematicsRoutePoint } from '../../../../../../../common/interfaces/telematics/telematics-route-point';
import { FleetIdentifierPipe } from '../../../../../../../common/pipes/fleet-identifier.pipe';
import { RouteService } from '../../../../../../../common/services/route.service';
import { FleetHelper } from '../../../../../../fleet/common/helpers/fleet.helper';
import type { SimplifiedFleet } from '../../../../../../fleet/common/interfaces/fleet';

@Component({
  selector: 'app-swap-modal-route-item',
  imports: [
    OnyxInformationHeadingComponent,
    OnyxLinkComponent,
    TranslatePipe,
    FleetIdentifierPipe,
    forwardRef(() => RouteComponent),
  ],
  providers: [RouteService],
  templateUrl: './swap-modal-route-item.component.html',
  styleUrl: './swap-modal-route-item.component.scss',
})
export class SwapModalRouteItemComponent implements OnInit {
  private readonly routeService = inject(RouteService);
  private readonly injector = inject(Injector);
  private readonly fleetHelper = inject(FleetHelper);

  public readonly route = input.required<TelematicsRoutePoint[]>();
  public readonly vehicleUuid = input.required<string | null>();
  public readonly fuelType = input.required<OnyxOptional<FuelType>>();
  public readonly heading = input.required<string>();
  public readonly identifierColor = input<OnyxColor | null>();
  public readonly areRoutesExpanded = input(false);
  public readonly showRegistrationNumbers = input(false);
  public readonly vehicle = input<SimplifiedFleet | null>(null);
  public readonly trailer = input<SimplifiedFleet | null>(null);

  public ngOnInit(): void {
    this.routeService.showFirstEmptyRoute.set(false);

    effect(() => this.routeService.points.set(this.route()), {
      injector: this.injector,
    });

    effect(
      () => {
        this.route();
        const expanded = this.areRoutesExpanded();

        untracked(() => this.routeService.toggleRouteExpanded(expanded));
      },
      { injector: this.injector },
    );
  }

  protected openFleetModal(fleet: SimplifiedFleet | null): void {
    if (fleet) this.fleetHelper.openModal(fleet);
  }
}
